/**
 * useTheme — light/dark theme resolver.
 *
 * Resolves the effective theme from the user's stored choice, light when
 * there is none. Light is the default on purpose, a design decision of
 * 11 Mar 2026, so `prefers-color-scheme` is only consulted when the stored
 * choice is "auto". Mirrors the result onto `data-theme` on <html> so the
 * CSS variables switch.
 *
 * Consumers: App.tsx (theme toggle in settings); CSS reads data-theme.
 */
import type { ThemeMode } from '../types/index.ts';

export function detectTheme(): ThemeMode {
  return (localStorage.getItem("fornland-theme") as ThemeMode) || "light";
}

export function resolveTheme(mode: ThemeMode): "dark" | "light" {
  if (mode === "auto") return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  return mode;
}
